
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	footer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		marginTop: "auto",
	},
}));